import { useEffect, useState } from "react";
import { puedeCrear } from "../auth/permisos";
import DateInput from "../../shared/components/DateInput";

import { avisarError } from "../../shared/errores";
import { directorioMiembros, eliminar as eliminarFila, guardar as guardarFila, listar, unir } from "../../services/datos";
import { avisar, confirmar } from "../../shared/avisos";
import Selector from "../../shared/components/Selector";
import Esqueleto from "../../shared/components/Esqueleto";

const camposVacios = {
  nombres: "",
  apellidos: "",
  fecha_nacimiento: "",
  genero: "",
  tutor_id: "",
  alergias: "",
  condicion_medica: "",
  activo: true,
};

function calcularEdad(fechaNacimiento) {
  if (!fechaNacimiento) return "";
  const nacimiento = new Date(fechaNacimiento + "T00:00:00");
  const hoy = new Date();
  let edad = hoy.getFullYear() - nacimiento.getFullYear();
  const mes = hoy.getMonth() - nacimiento.getMonth();
  if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
    edad -= 1;
  }
  return edad;
}

function FormularioNino({ inicial, miembros, onGuardar, onCancelar }) {
  const [form, setForm] = useState(inicial || camposVacios);
  const [busquedaTutor, setBusquedaTutor] = useState("");

  useEffect(() => {
    if (inicial) {
      const { miembros, familias, ...rest } = inicial;
      setForm({
        ...camposVacios,
        ...rest,
        tutor_id: inicial.tutor_id ? String(inicial.tutor_id) : "",
        familia_id: inicial.familia_id ? String(inicial.familia_id) : "",
        activo: inicial.activo ?? true,
      });
      if (inicial.miembros) {
        setBusquedaTutor(`${inicial.miembros.nombres} ${inicial.miembros.apellidos}`);
      }
    } else {
      setForm(camposVacios);
      setBusquedaTutor("");
    }
  }, [inicial]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = () => {
    if (!form.nombres || !form.apellidos || !form.fecha_nacimiento) {
      avisar("Nombres, apellidos y fecha de nacimiento son obligatorios");
      return;
    }
    onGuardar(form);
  };

  const tutorSeleccionado = miembros.find((m) => m.id === parseInt(form.tutor_id));
  const busquedaLimpia = busquedaTutor.trim().toLowerCase();
  const tutoresFiltrados = miembros
    .filter((m) => {
      if (!busquedaLimpia || tutorSeleccionado) return false;
      const nombreCompleto = `${m.nombres} ${m.apellidos}`.toLowerCase();
      const correo = String(m.email || "").toLowerCase();
      return nombreCompleto.includes(busquedaLimpia) || correo.includes(busquedaLimpia);
    })
    .slice(0, 8);

  const input = "campo";
  const label = "etiqueta";

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-black/80 p-4 backdrop-blur-sm ventana-fondo">
      <div className="w-full max-w-2xl max-h-screen overflow-y-auto rounded-2xl border border-white/10 bg-zinc-950 p-6 sm:p-8 ventana-panel">
        <h3 className="text-xl font-black uppercase tracking-tight text-white mb-6">
          {inicial ? "Editar Niño" : "Nuevo Niño"}
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className={label}>Nombres *</label>
            <input name="nombres" value={form.nombres} onChange={handleChange} className={input} placeholder="Nombres" />
          </div>

          <div>
            <label className={label}>Apellidos *</label>
            <input name="apellidos" value={form.apellidos} onChange={handleChange} className={input} placeholder="Apellidos" />
          </div>

          <DateInput label="Fecha de nacimiento *" name="fecha_nacimiento" value={form.fecha_nacimiento} onChange={handleChange} className={input} />

          <div>
            <label className={label}>Género</label>
            <Selector name="genero" value={form.genero || ""} onChange={handleChange} className={input}>
              <option value="">Seleccionar</option>
              <option value="masculino">Masculino</option>
              <option value="femenino">Femenino</option>
            </Selector>
          </div>

          <div className="md:col-span-2">
            <label className={label}>Tutor o acudiente</label>
            <input
              type="text"
              value={busquedaTutor}
              onChange={(e) => {
                setBusquedaTutor(e.target.value);
                setForm({ ...form, tutor_id: "" });
              }}
              className={input}
              placeholder="Buscar miembro por nombre o correo"
            />

            {tutorSeleccionado && (
              <div className="mt-3 flex items-center justify-between rounded-xl border border-dorado bg-oscuro p-3">
                <div>
                  <p className="text-white text-sm font-semibold">
                    {tutorSeleccionado.nombres} {tutorSeleccionado.apellidos}
                  </p>
                  <p className="text-gray-400 text-xs">{tutorSeleccionado.estado}</p>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    setForm({ ...form, tutor_id: "" });
                    setBusquedaTutor("");
                  }}
                  className="text-red-400 text-sm hover:text-red-300"
                >
                  Quitar
                </button>
              </div>
            )}

            {!tutorSeleccionado && busquedaLimpia && (
              <div className="mt-3 max-h-56 overflow-y-auto rounded-xl border border-gray-700">
                {tutoresFiltrados.length === 0 ? (
                  <p className="p-3 text-sm text-gray-400">No se encontraron miembros.</p>
                ) : (
                  tutoresFiltrados.map((m) => (
                    <button
                      key={m.id}
                      type="button"
                      onClick={() => {
                        setForm({ ...form, tutor_id: String(m.id) });
                        setBusquedaTutor(`${m.nombres} ${m.apellidos}`);
                      }}
                      className="w-full border-b border-gray-700 p-3 text-left transition last:border-b-0 hover:bg-oscuro"
                    >
                      <p className="text-white text-sm font-semibold">{m.nombres} {m.apellidos}</p>
                      <p className="text-gray-400 text-xs">{m.estado}</p>
                    </button>
                  ))
                )}
              </div>
            )}
          </div>

          <div>
            <label className={label}>Alergias</label>
            <textarea name="alergias" value={form.alergias || ""} onChange={handleChange} className={input} rows={3} placeholder="Alergias conocidas" />
          </div>

          <div>
            <label className={label}>Condición médica</label>
            <textarea name="condicion_medica" value={form.condicion_medica || ""} onChange={handleChange} className={input} rows={3} placeholder="Información médica importante" />
          </div>
        </div>

        <label className="mt-4 flex items-center gap-2 text-sm text-gray-300">
          <input type="checkbox" name="activo" checked={Boolean(form.activo)} onChange={handleChange} />
          Niño activo en el ministerio infantil
        </label>

        <div className="flex gap-3 mt-6">
          <button onClick={handleSubmit} className="flex-1 btn-primario">
            Guardar
          </button>
          <button onClick={onCancelar} className="flex-1 btn-fantasma">
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

function Ninos({ usuario }) {
  const [ninos, setNinos] = useState([]);
  const [miembros, setMiembros] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [busqueda, setBusqueda] = useState("");
  const [filtroActivo, setFiltroActivo] = useState("activos");
  const [mostrarForm, setMostrarForm] = useState(false);
  const [ninoEditar, setNinoEditar] = useState(null);

  const cargarDatos = () => {
    setCargando(true);
    Promise.all([
      listar("ninos", { orden: "apellidos" }),
      directorioMiembros(),
    ])
      .then(([ninosData, miembrosData]) => {
        // El tutor se muestra con su nombre (antes venía embebido desde la API).
        setNinos(unir(ninosData, "tutor_id", miembrosData, "miembros"));
        setMiembros(miembrosData);
        setCargando(false);
      })
      .catch((e) => { setCargando(false); avisarError(e); });
  };

  useEffect(() => { cargarDatos(); }, []);

  const guardarNino = (form) => {
    const body = {
      nombres: form.nombres,
      apellidos: form.apellidos,
      fecha_nacimiento: form.fecha_nacimiento,
      genero: form.genero,
      tutor_id: form.tutor_id,
      alergias: form.alergias,
      condicion_medica: form.condicion_medica,
      activo: form.activo,
      familia_id: form.familia_id,
    };

    guardarFila("ninos", ninoEditar?.id, body)
      .then(() => {
        setMostrarForm(false);
        setNinoEditar(null);
        cargarDatos();
      })
      .catch((error) => avisar(error.message || "No se pudo guardar el niño. Revise la información.", "error"));
  };

  const eliminarNino = async (id, nombre) => {
    if ((await confirmar(`¿Eliminar a ${nombre}?`, { aceptar: "Eliminar" }))) {
      eliminarFila("ninos", id).then(() => cargarDatos()).catch((e) => avisar(e.message, "error"));
    }
  };

  const ninosFiltrados = ninos.filter((n) => {
    const texto = `${n.nombres} ${n.apellidos}`.toLowerCase();
    const tutor = n.miembros ? `${n.miembros.nombres} ${n.miembros.apellidos}`.toLowerCase() : "";
    const coincideBusqueda = texto.includes(busqueda.toLowerCase()) || tutor.includes(busqueda.toLowerCase());
    const coincideActivo =
      filtroActivo === "todos" ||
      (filtroActivo === "activos" && n.activo) ||
      (filtroActivo === "inactivos" && !n.activo);
    return coincideBusqueda && coincideActivo;
  });

  const activos = ninos.filter((n) => n.activo).length;
  const conAlertas = ninos.filter((n) => n.alergias || n.condicion_medica).length;

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="titulo-pagina">Niños</h2>
          <p className="text-gray-400 text-sm mt-1">{activos} activos · {conAlertas} con alertas médicas</p>
        </div>
        {puedeCrear(usuario) ? (
          <button
            onClick={() => { setNinoEditar(null); setMostrarForm(true); }}
            className="btn-primario"
          >
            Nuevo Niño
          </button>
        ) : (
          <span className="text-sm text-gray-400">Solo pastor o administrador puede crear</span>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <div className="panel p-4">
          <p className="text-gray-400 text-xs">Total registrados</p>
          <p className="text-white text-3xl font-bold">{ninos.length}</p>
        </div>
        <div className="panel border-emerald-500/30 p-4">
          <p className="text-gray-400 text-xs">Activos</p>
          <p className="text-white text-3xl font-bold">{activos}</p>
        </div>
        <div className="panel border-rose-500/30 p-4">
          <p className="text-gray-400 text-xs">Alertas médicas</p>
          <p className="text-white text-3xl font-bold">{conAlertas}</p>
        </div>
      </div>

      <div className="flex gap-4 mb-6 flex-wrap">
        <input
          type="text"
          placeholder="Buscar por niño o tutor..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          className="flex-1 min-w-48 campo"
        />
        <Selector
          value={filtroActivo}
          onChange={(e) => setFiltroActivo(e.target.value)}
          className="campo w-auto"
        >
          <option value="activos">Activos</option>
          <option value="inactivos">Inactivos</option>
          <option value="todos">Todos</option>
        </Selector>
      </div>

      {cargando ? (
        <Esqueleto tipo="tarjetas" texto="Cargando niños…" />
      ) : ninosFiltrados.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-400 text-lg">No hay niños registrados aún</p>
          <p className="text-gray-600 text-sm mt-2">Haz clic en "Nuevo Niño" para agregar el primero</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {ninosFiltrados.map((n) => (
            <div key={n.id} className="panel p-5 hover:border-dorado transition">
              <div className="flex items-start justify-between gap-3 mb-3">
                <div>
                  <p className="text-white font-bold">{n.nombres} {n.apellidos}</p>
                  <p className="text-gray-400 text-sm">
                    {calcularEdad(n.fecha_nacimiento)} años · {n.genero || "Sin género"}
                  </p>
                </div>
                <span className={`insignia ${n.activo ? "border border-emerald-500/30 bg-emerald-500/15 text-emerald-300" : "border border-zinc-500/30 bg-zinc-500/15 text-zinc-400"}`}>
                  {n.activo ? "activo" : "inactivo"}
                </span>
              </div>

              <div className="text-gray-400 text-sm space-y-1 mb-4">
                <p>Nacimiento: {new Date(n.fecha_nacimiento + "T00:00:00").toLocaleDateString("es-CO")}</p>
                <p>Tutor: {n.miembros ? `${n.miembros.nombres} ${n.miembros.apellidos}` : "Sin tutor"}</p>
                {n.alergias && <p className="text-red-300">Alergias: {n.alergias}</p>}
                {n.condicion_medica && <p className="text-yellow-300">Condición médica: {n.condicion_medica}</p>}
              </div>

              {puedeCrear(usuario) && (
              <div className="flex gap-2">
                <button
                  onClick={() => { setNinoEditar(n); setMostrarForm(true); }}
                  className="flex-1 btn-fantasma btn-sm"
                >
                  Editar
                </button>
                <button
                  onClick={() => eliminarNino(n.id, n.nombres)}
                  className="flex-1 btn-peligro btn-sm"
                >
                  Eliminar
                </button>
              </div>
              )}
            </div>
          ))}
        </div>
      )}

      {mostrarForm && (
        <FormularioNino
          inicial={ninoEditar}
          miembros={miembros}
          onGuardar={guardarNino}
          onCancelar={() => { setMostrarForm(false); setNinoEditar(null); }}
        />
      )}
    </div>
  );
}

export default Ninos;
